/**
 * 失败图标
 */
const ErrorIcon = ({ width = 16, height = 16, color = '#DA291C' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.0001 7.99999C14.0001 11.3137 11.3138 14 8.00008 14C4.68637 14 2.00008 11.3137 2.00008 7.99999C2.00008 4.68628 4.68637 1.99999 8.00008 1.99999C11.3138 1.99999 14.0001 4.68628 14.0001 7.99999ZM8.00008 15.3333C12.0502 15.3333 15.3334 12.0501 15.3334 7.99999C15.3334 3.9499 12.0502 0.666656 8.00008 0.666656C3.94999 0.666656 0.666748 3.9499 0.666748 7.99999C0.666748 12.0501 3.94999 15.3333 8.00008 15.3333ZM7.33333 4.67871L7.33333 8.65576L8 9.29948L8.66667 8.65576L8.66667 4.67871H7.33333ZM8.66673 11.3343V10.6906L8.00006 10.0469L7.33339 10.6906L7.33339 11.3343L8.66673 11.3343Z"
        fill={color}
      />
    </svg>
  )
}

export default ErrorIcon
